import {PERM} from "../utilites/permissions";
import WorkTypeCatalogs from "../components/Catalogs/WorkType/WorkTypeCatalogs";
import WorkTypeCatalog from "../components/Catalogs/WorkType/WorkTypeCatalog";
import TownCatalogs from "../components/Catalogs/Towns/TownCatalogs";
import TownCatalog from "../components/Catalogs/Towns/TownCatalog";
import MarketingSources from "../components/Catalogs/MarketingSources/MarketingSources";
import MarketingSource from "../components/Catalogs/MarketingSources/MarketingSource";
import WorkerSources from "../components/Catalogs/WorkerSources/WorkerSources";
import WorkerSource from "../components/Catalogs/WorkerSources/WorkerSource";
import JobTitles from "../components/Catalogs/JobTitles/JobTitles";
import JobTitle from "../components/Catalogs/JobTitles/JobTitle";
import LocationCostTypes from "../components/Catalogs/LocationCostTypes/LocationCostTypes";
import LocationCostType from "../components/Catalogs/LocationCostTypes/LocationCostType";
import WorkerCostTypes from "../components/Catalogs/WorkerCostTypes/WorkerCostTypes";
import WorkerCostType from "../components/Catalogs/WorkerCostTypes/WorkerCostType";
import Departments from "../components/Catalogs/Departments/Departments";
import Department from "../components/Catalogs/Departments/Department";
import WorkServices from "../components/Catalogs/WorkServices/WorkServices";
import WorkService from "../components/Catalogs/WorkServices/WorkService";
import Vacancies from "../components/Catalogs/Vacancies/Vacancies";
import Vacancy from "../components/Catalogs/Vacancies/Vacancy";
import LocationStatuses from "../components/Catalogs/LocationStatuses/LocationStatuses.vue";
import LocationStatus from "../components/Catalogs/LocationStatuses/LocationStatus.vue";
import ProjectStatuses from "../components/Catalogs/ProjectStatuses/ProjectStatuses.vue";
import ProjectStatus from "../components/Catalogs/ProjectStatuses/ProjectStatus.vue";
import LeadStatuses from "../components/Catalogs/LeadStatuses/LeadStatuses.vue";
import LeadStatus from "../components/Catalogs/LeadStatuses/LeadStatus.vue";
import CustomerStatuses from "../components/Catalogs/CustomerStatuses/CustomerStatuses.vue";
import CustomerStatus from "../components/Catalogs/CustomerStatuses/CustomerStatus.vue";
import LeadSources from "../components/Catalogs/LeadSources/LeadSources.vue";
import LeadSource from "../components/Catalogs/LeadSources/LeadSource.vue";
import RecruitTags from "../components/Catalogs/RecruitTags/RecruitTags.vue";
import RecruitTag from "../components/Catalogs/RecruitTags/RecruitTag.vue";
import WorkerStatuses from "../components/Catalogs/WorkerStatuses/WorkerStatuses.vue";
import WorkerStatus from "../components/Catalogs/WorkerStatuses/WorkerStatus.vue";
import Citizenships from "../components/Catalogs/Citizenships/Citizenships.vue";
import Citizenship from "../components/Catalogs/Citizenships/Citizenship.vue";
import DriverLicenseCategories from "../components/Catalogs/DriverLicenseCategories/DriverLicenseCategories.vue";
import DriverLicenseCategory from "../components/Catalogs/DriverLicenseCategories/DriverLicenseCategory.vue";
import EmploymentCategories from "../components/Catalogs/EmploymentCategories/EmploymentCategories.vue";
import EmploymentCategory from "../components/Catalogs/EmploymentCategories/EmploymentCategory.vue";
import WorkerSkill from  "../components/Catalogs/WorkerSkills/WorkerSkill.vue"
import WorkerSkills from  "../components/Catalogs/WorkerSkills/WorkerSkills.vue"
import WorkerComplaint from "../components/Catalogs/WorkerComplaints/WorkerComplaint"
import WorkerComplaints from "../components/Catalogs/WorkerComplaints/WorkerComplaints"
import TaskWorkerStatus from "../components/Catalogs/TaskWorkerStatuses/TaskWorkerStatus";
import TaskWorkerStatuses from "../components/Catalogs/TaskWorkerStatuses/TaskWorkerStatuses";

const catalogsHandler = ({
  path, modalName, tableName, modalComponent, tableComponent, perm, permEdit, permRead,
}) => {
  return {
    path,
    name: tableName,
    component: tableComponent,
    meta: {
      requiresAuth: true,
      permissions: [perm],
    },
    props: true,
    children: [
      {
        path: 'new',
        name: `${modalName}Add`,
        component: modalComponent,
        meta: {
          requiresAuth: true,
          permissions: [perm, permEdit],
        },
        props: true,
      },
      {
        path: 'edit/:id',
        name: `${modalName}Edit`,
        component: modalComponent,
        meta: {
          requiresAuth: true,
          permissions: [
            perm,
            permEdit,
            permRead,
          ],
        },
        props: true,
      },
      {
        path: 'view/:id',
        name: `${modalName}View`,
        component: modalComponent,
        meta: {
          requiresAuth: true,
          permissions: [
            perm,
            permRead,
          ],
        },
        props: true,
      },
    ]
  };
};

const configuration = [
  {
    path: '/town_catalogs',
    modalName: 'TownCatalog',
    tableName: 'TownCatalogs',
    modalComponent: TownCatalog,
    tableComponent: TownCatalogs,
    perm: PERM.CATALOG_TOWN,
    permEdit: PERM.CATALOG_TOWN_EDIT,
    permRead: PERM.CATALOG_TOWN_READ,
  },
  {
    path: '/work_type_catalogs',
    modalName: 'WorkTypeCatalog',
    tableName: 'WorkTypeCatalogs',
    modalComponent: WorkTypeCatalog,
    tableComponent: WorkTypeCatalogs,
    perm: PERM.CATALOG_WORK_TYPE,
    permEdit: PERM.CATALOG_WORK_TYPE_EDIT,
    permRead: PERM.CATALOG_WORK_TYPE_READ,
  },
  {
    path: '/marketing_sources',
    modalName: 'MarketingSource',
    tableName: 'MarketingSources',
    modalComponent: MarketingSource,
    tableComponent: MarketingSources,
    perm: PERM.CATALOG_SOURCE,
    permEdit: PERM.CATALOG_SOURCE_EDIT,
    permRead: PERM.CATALOG_SOURCE_READ,
  },
  {
    path: '/worker_sources',
    modalName: 'WorkerSource',
    tableName: 'WorkerSources',
    modalComponent: WorkerSource,
    tableComponent: WorkerSources,
    perm: PERM.CATALOG_WORKER_SOURCE,
    permEdit: PERM.CATALOG_WORKER_SOURCE_EDIT,
    permRead: PERM.CATALOG_WORKER_SOURCE_READ,
  },
  {
    path: '/job_titles',
    modalName: 'JobTitle',
    tableName: 'JobTitles',
    modalComponent: JobTitle,
    tableComponent: JobTitles,
    perm: PERM.CATALOG_JOB_TITLE,
    permEdit: PERM.CATALOG_JOB_TITLE_EDIT,
    permRead: PERM.CATALOG_JOB_TITLE_READ,
  },
  {
    path: '/location_cost_types',
    modalName: 'LocationCostType',
    tableName: 'LocationCostTypes',
    modalComponent: LocationCostType,
    tableComponent: LocationCostTypes,
    perm: PERM.CATALOG_LOCATION_COST_TYPE,
    permEdit: PERM.CATALOG_LOCATION_COST_TYPE_EDIT,
    permRead: PERM.CATALOG_LOCATION_COST_TYPE_READ,
  },
  {
    path: '/location_statuses',
    modalName: 'LocationStatus',
    tableName: 'LocationStatuses',
    modalComponent: LocationStatus,
    tableComponent: LocationStatuses,
    perm: PERM.CATALOG_LOCATION_STATUS,
    permEdit: PERM.CATALOG_LOCATION_STATUS_EDIT,
    permRead: PERM.CATALOG_LOCATION_STATUS_READ,
  },
  {
    path: '/worker_cost_types',
    modalName: 'WorkerCostType',
    tableName: 'WorkerCostTypes',
    modalComponent: WorkerCostType,
    tableComponent: WorkerCostTypes,
    perm: PERM.CATALOG_WORKER_COST_TYPE,
    permEdit: PERM.CATALOG_WORKER_COST_TYPE_EDIT,
    permRead: PERM.CATALOG_WORKER_COST_TYPE_READ,
  },
  {
    path: '/departments',
    modalName: 'Department',
    tableName: 'Departments',
    modalComponent: Department,
    tableComponent: Departments,
    perm: PERM.CATALOG_DEPARTMENT,
    permEdit: PERM.CATALOG_DEPARTMENT_EDIT,
    permRead: PERM.CATALOG_DEPARTMENT_READ,
  },
  {
    path: '/work_services',
    modalName: 'WorkService',
    tableName: 'WorkServices',
    modalComponent: WorkService,
    tableComponent: WorkServices,
    perm: PERM.CATALOG_WORK_SERVICE,
    permEdit: PERM.CATALOG_WORK_SERVICE_EDIT,
    permRead: PERM.CATALOG_WORK_SERVICE_READ,
  },
  {
    path: '/vacancies',
    modalName: 'Vacancy',
    tableName: 'Vacancies',
    modalComponent: Vacancy,
    tableComponent: Vacancies,
    perm: PERM.CATALOG_VACANCY,
    permEdit: PERM.CATALOG_VACANCY_EDIT,
    permRead: PERM.CATALOG_VACANCY_READ,
  },
  {
    path: '/lead_statuses',
    modalName: 'LeadStatus',
    tableName: 'LeadStatuses',
    modalComponent: LeadStatus,
    tableComponent: LeadStatuses,
    perm: PERM.CATALOG_LEAD_STATUS,
    permEdit: PERM.CATALOG_LEAD_STATUS_EDIT,
    permRead: PERM.CATALOG_LEAD_STATUS_READ,
  },
  {
    path: '/project_statuses',
    modalName: 'ProjectStatus',
    tableName: 'ProjectStatuses',
    modalComponent: ProjectStatus,
    tableComponent: ProjectStatuses,
    perm: PERM.CATALOG_PROJECT_STATUS,
    permEdit: PERM.CATALOG_PROJECT_STATUS_EDIT,
    permRead: PERM.CATALOG_PROJECT_STATUS_READ,
  },
  {
    path: '/customer_statuses',
    modalName: 'CustomerStatus',
    tableName: 'CustomerStatuses',
    modalComponent: CustomerStatus,
    tableComponent: CustomerStatuses,
    perm: PERM.CATALOG_CUSTOMER_STATUS,
    permEdit: PERM.CATALOG_CUSTOMER_STATUS_EDIT,
    permRead: PERM.CATALOG_CUSTOMER_STATUS_READ,
  },
  {
    path: '/lead_sources',
    modalName: 'LeadSource',
    tableName: 'LeadSources',
    modalComponent: LeadSource,
    tableComponent: LeadSources,
    perm: PERM.CATALOG_LEAD_SOURCE,
    permEdit: PERM.CATALOG_LEAD_SOURCE_EDIT,
    permRead: PERM.CATALOG_LEAD_SOURCE_READ,
  },
  {
    path: '/recruit_tags',
    modalName: 'RecruitTag',
    tableName: 'RecruitTags',
    modalComponent: RecruitTag,
    tableComponent: RecruitTags,
    perm: PERM.CATALOG_RECRUIT_TAG,
    permEdit: PERM.CATALOG_RECRUIT_TAG_EDIT,
    permRead: PERM.CATALOG_RECRUIT_TAG_READ,
  },
  {
    path: '/worker_statuses',
    modalName: 'WorkerStatus',
    tableName: 'WorkerStatuses',
    modalComponent: WorkerStatus,
    tableComponent: WorkerStatuses,
    perm: PERM.CATALOG_WORKER_STATUS,
    permEdit: PERM.CATALOG_WORKER_STATUS_EDIT,
    permRead: PERM.CATALOG_WORKER_STATUS_READ,
  },
  {
    path: '/citizenships',
    modalName: 'Citizenship',
    tableName: 'Citizenships',
    modalComponent: Citizenship,
    tableComponent: Citizenships,
    perm: PERM.CATALOG_CITIZENSHIPS,
    permEdit: PERM.CATALOG_CITIZENSHIPS_EDIT,
    permRead: PERM.CATALOG_CITIZENSHIPS_READ,
  },
  {
    path: '/driver_license_categories',
    modalName: 'DriverLicenseCategory',
    tableName: 'DriverLicenseCategories',
    modalComponent: DriverLicenseCategory,
    tableComponent: DriverLicenseCategories,
    perm: PERM.CATALOG_DRIVER_LICENSE_CATEGORY,
    permEdit: PERM.CATALOG_DRIVER_LICENSE_CATEGORY_EDIT,
    permRead: PERM.CATALOG_DRIVER_LICENSE_CATEGORY_READ,
  },
  {
    path: '/employment_categories',
    modalName: 'EmploymentCategory',
    tableName: 'EmploymentCategories',
    modalComponent: EmploymentCategory,
    tableComponent: EmploymentCategories,
    perm: PERM.CATALOG_EMPLOYMENT_CATEGORY,
    permEdit: PERM.CATALOG_EMPLOYMENT_CATEGORY_EDIT,
    permRead: PERM.CATALOG_EMPLOYMENT_CATEGORY_READ,
  },
  {
    path: '/worker_skills',
    modalName: 'WorkerSkill',
    tableName: 'WorkerSkills',
    modalComponent: WorkerSkill,
    tableComponent: WorkerSkills,
    perm: PERM.CATALOG_WORKER_SKILLS,
    permEdit: PERM.CATALOG_WORKER_SKILLS_EDIT,
    permRead: PERM.CATALOG_WORKER_SKILLS_READ,
  },
  {
    path: '/worker_complaints',
    modalName: 'WorkerComplaint',
    tableName: 'WorkerComplaints',
    modalComponent: WorkerComplaint,
    tableComponent: WorkerComplaints,
    perm: PERM.CATALOG_WORKER_COMPLAINTS,
    permEdit: PERM.CATALOG_WORKER_COMPLAINTS_EDIT,
    permRead: PERM.CATALOG_WORKER_COMPLAINTS_READ,
  },
  {
    path: '/task_worker_statuses',
    modalName: 'TaskWorkerStatus',
    tableName: 'TaskWorkerStatuses',
    modalComponent: TaskWorkerStatus,
    tableComponent: TaskWorkerStatuses,
    perm: PERM.CATALOG,
    permEdit: PERM.CATALOG_EDIT,
    permRead: PERM.CATALOG,
  },
];

const catalogs = configuration.map(catalogsHandler);

export default catalogs;



// WEBPACK FOOTER //
// ./src/router/catalogs.js